import React, { useEffect } from 'react';

import { HeadObj } from '@/objects/Page';
import { pathToSection, traduccionesPorPathHead } from '@/util/internacionalizacion/TraduccionesPorPath';
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import ContenidoPerfil from '@/components/elements/ContenidoPerfil';
import MenuPerfil from '@/components/widgets/perfil/MenuPerfil';
import { SeccionesPerfil, menuActividad, menuCuenta, menuOtros } from '@/objects/Menus';
import { cargarDatosUsuario, removeUserData } from '@/util/LocalStorageLoaded';
import PerfilUsuario from '@/components/widgets/perfil/PerfilUsuario';
import { abrirAlertInicioSesion } from '@/util/Comun';
import MisLibros from '@/components/widgets/perfil/MisLibros';
import { useRouter } from 'next/router';
import LibrosFavoritosScreen from '@/components/widgets/perfil/LibrosFavoritos';
import Premium from '@/components/widgets/perfil/Premium';
import Creditos from '@/components/widgets/perfil/Creditos';
import Logros from '@/components/widgets/perfil/Logros';
import PuntuacionesUser from '@/components/widgets/perfil/PuntuacionesUser';
import PreguntasFrecuentes from '../preguntas-frecuentes';
import PuntuacionesLibros from '@/components/widgets/perfil/PuntuacionesLibros';
import { resolucionMovilDashboard } from '@/util/Util';
import { mostrarDialogActivity } from '@/context/UtilsContext';
import ChatAyuda from '@/components/widgets/ChatAyuda';
import { cerrarDialogActivity } from '@/components/elements/DialogActivity';
import { NotificationContextProvider } from '@/context/NotificationContext';
import MenuMensajes from '@/components/widgets/perfil/MenuMensajes';
import MenuEstadisticas from '@/components/widgets/perfil/MenuEstadisticas';
import ImportarExportar from '@/components/widgets/perfil/ImportarExportar';
import RankingLogros from '@/components/widgets/perfil/RankingLogros';
import ComprasMenu from '@/components/widgets/perfil/ComprasMenu';
import AlertasLibros from '@/components/widgets/perfil/AlertasLibros';

interface DasboardProps {
  pathActual: string;
  locale: string;
}

const Dashboard: React.FC<DasboardProps> = ({ locale, pathActual }) => {
  const router = useRouter();
  const { path } = router.query;
  //console.log('Path:' + path);

  const { t } = useTranslation();

  //const {setLoading} = useServices();

  const [opcionActual, setOpcionActual] = React.useState<SeccionesPerfil>(SeccionesPerfil.DEFAULT);
  const [cargadoUnaVez, setCargadoUnaVez] = React.useState<boolean>(false);

  const [esMovil, setEsMovil] = React.useState<boolean>(false);

  //Para cerrar el dialogo de actividad
  React.useEffect(() => {
    if (!esMovil) return;

    const handlePopState = () => {
      cerrarDialogActivity();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [esMovil]);


  useEffect(() => {
    if (cargarDatosUsuario() == null) {
      return;
    }
    // Establecer cargadoUnaVez en true después de la primera renderización
    setCargadoUnaVez(true);
    setEsMovil(resolucionMovilDashboard());
  }, []);

  useEffect(() => {
    if (cargarDatosUsuario() == null) {
      return;
    }
    // Verificar si es la primera carga y si el path es AJUSTES_PERFIL
    if (!cargadoUnaVez && path === SeccionesPerfil.AJUSTES_PERFIL && resolucionMovilDashboard()) {
      // Si es resolución móvil, establecer la opción actual en DEFAULT
      setOpcionActual(SeccionesPerfil.DEFAULT);
      return; // Salir del useEffect después de establecer la opción actual
    } else {
      if (!cargadoUnaVez) {
        setOpcionActual(path as SeccionesPerfil);
      }
    }
  }, [path, cargadoUnaVez]);

  useEffect(() => {
    //Si la opcion seleccionada es cerrar sesion
    if (opcionActual === SeccionesPerfil.CERRAR_SESION) {
      removeUserData();
      //Carga pagina principal
      window.location.href = "/";
    } else {
      if (resolucionMovilDashboard()) {
        if (opcionActual !== SeccionesPerfil.DEFAULT) {
          //Para la clave hay que buscar que coincida con las listas menuCuenta o menuActividad o menuOtros
          let titulo = "";
          if (menuCuenta.find((opcion) => opcion.clave_seccion === opcionActual)) {
            titulo = menuCuenta.find((opcion) => opcion.clave_seccion === opcionActual)!.titulo;
          } else if (menuActividad.find((opcion) => opcion.clave_seccion === opcionActual)) {
            titulo = menuActividad.find((opcion) => opcion.clave_seccion === opcionActual)!.titulo;
          } else if (menuOtros.find((opcion) => opcion.clave_seccion === opcionActual)) {
            titulo = menuOtros.find((opcion) => opcion.clave_seccion === opcionActual)!.titulo;
          }
          mostrarDialogActivity({
            title: t(titulo),
            children:
              <NotificationContextProvider pathActual={pathActual}>
                {obtenerOpcionActual(opcionActual)}
              </NotificationContextProvider>,
            onClose: () => {
              setOpcionActual(SeccionesPerfil.DEFAULT);
            }
          });
        }
      }
    }
    //mostrarLogro({ completado: true, descripcion: "Logro completado", id: 1, nombre: "Logro 1", puntos: 10, tipo: TipoLogro.FUEGO }, t, false);
  }, [opcionActual]);

  useEffect(() => {
    //Comprueba que has iniciado sesion
    if (cargarDatosUsuario() == null) {
      abrirAlertInicioSesion(t);
      return;
    }
    //Elimina el componente : id footer_page
    const footer = document.getElementById("footer_page");
    if (footer) {
      footer.style.display = "none";  // Cambiar display a "none" para ocultar
    }

    //Quita al body el scroll
    document.body.style.overflow = "hidden";

    // Cleanup: Restablece el scroll cuando el componente se desmonte
    return () => {
      document.body.style.overflow = "auto";  // Restaurar scroll
      if (footer) {
        footer.style.display = "block";  // Vuelve a mostrar el footer
      }
    };
  }, []);

  function obtenerOpcionActual(opcionActual: SeccionesPerfil): React.ReactNode {
    switch (opcionActual) {
      case SeccionesPerfil.MENSAJES:
        return <MenuMensajes />;
      case SeccionesPerfil.MIS_LIBROS:
        return <MisLibros />;
      case SeccionesPerfil.IMPORTAR_EXPORTAR:
        return <ImportarExportar />;
      case SeccionesPerfil.FAVORITOS:
        return <LibrosFavoritosScreen />;
      case SeccionesPerfil.MIS_COMPRAS:
        return <ComprasMenu />;
      case SeccionesPerfil.PREMIUM:
        return <Premium />;
      case SeccionesPerfil.CONSEGUIR_CREDITOS:
        return <Creditos />;
      case SeccionesPerfil.AJUSTES_PERFIL:
        return <PerfilUsuario />;
      case SeccionesPerfil.PUNTUACIONES:
        return <PuntuacionesUser />;
      case SeccionesPerfil.LOGROS:
        return <Logros />;
      case SeccionesPerfil.RANKING:
        return <RankingLogros />;
      case SeccionesPerfil.MIS_PUNTUACIONES_LIBROS:
        return <PuntuacionesLibros />;
      case SeccionesPerfil.AYUDA:
        return <PreguntasFrecuentes />;
      case SeccionesPerfil.CHAT_AYUDA:
        return <ChatAyuda locale={locale} />
      case SeccionesPerfil.ESTADISTICAS:
        return <MenuEstadisticas />
      case SeccionesPerfil.ALERTAS:
        return <AlertasLibros />
    }
  }

  return (
    <section>
      <ContenidoPerfil
        optionsComponent={
          <MenuPerfil
            opcionActual={opcionActual}
            opcionSeleccionada={setOpcionActual}
            t={t}
          />
        }
        contentComponent={
          !esMovil &&
          <div>
            {obtenerOpcionActual(opcionActual)}
          </div>
        }
      />
    </section>
  );
};

export default Dashboard;

//Generacion de articulos en el servidor para SEO
export async function getServerSideProps(context: any) {
  //Obtener categoria y last_id del path
  let { locale } = context;

  if (!locale) {
    locale = 'es'; // Reemplaza 'es' con tu localización predeterminada
  }

  const pathActual = pathToSection(context.resolvedUrl);
  const headerObj: HeadObj = await traduccionesPorPathHead(context, locale);

  //console.log('HeaderObj:' + headerObj.title);

  return {
    props: {
      headerObj: headerObj, // Pasar el objeto de encabezado
      pathActual: pathActual,
      locale: locale,
      ...(await serverSideTranslations(locale, ['common', "contenido", "preguntas", "header", "menu"])),
    },
  };
}
